export default __webpack_public_path__ + "static/media/People.c1e7947a.jpg";